/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import StepWizard from "react-step-wizard";
import "../../CSS/general.css";
import Step1 from "../AdditionLineControl/Step1";
import Step2 from "../AdditionLineControl/Step2";
import Step3 from "../AdditionLineControl/Step3";
import Step4 from "../AdditionLineControl/Step4";
import HelpModal from "../../components/MainComponents/HelpMessagePopup";
import AuthenticationContext from "../../Store/Authentication-Context";
import Axios from "axios";
import { API_ROUTE, Routes } from "../../Helpers/Constants";

const AdditionLineControlModal = props => {
    const [stepWizrd, setStepWizard] = useState(null);
    ////const [additionLines, setAdditionLines] = useState(null);
    const [uniqueAdditionLines, setUniqueAdditionLines] = useState([]);
    const [companies, setCompanies] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [helpPopup, setHelpPopup] = useState(true);
    const { setAuthContext } = useContext(AuthenticationContext);
    const [agreements, setAgreements] = useState(null);
    const [typesIds, setTypesIds] = useState(null);
    const assignStepWizard = (instance) => {

        setStepWizard(instance);
    };
    function closeHelpModal(params) {
        setHelpPopup(params);
    }


    const closeJobControlPopup = () => {
        stepWizrd.goToStep(1);
        stepWizrd.isActive = false;

        props.closeModal(true);
    }

    const handleStepChange = (e) => {
        setActiveStep(e.activeStep - 1);
    };
    const divStyle = {
        display: props.displayModal ? "block" : "none",
        zIndex: "10002"

    };

    const closePopupModal = () => {

        closeJobControlPopup();
        props.closeModal(true);
    }

    useEffect(() => {

        getAddditionLine();

       
    }, [])
    

    const updateAggreements = (uniqueLines) => {

        setUniqueAdditionLines((prevLines) => {
            // Check if prevLines exists, merge unique lines, and remove duplicates
            return prevLines ? [...new Set([...prevLines, ...uniqueLines])] : uniqueLines;
        });
    };
    const getallAggreements = async () => {
        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_AGREEMENTS, config)
            .then((response) => {

                if (response && response.data) {
                    let responsedata = response.data;

                    setAgreements(responsedata);

                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }

            });
    };
    
   async function getAddditionLine()
    {
        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
       await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_TYPEIDS, config)
           .then((response) => {

               if (response && response.data) {
                   let responsedata = response.data;

                   setTypesIds(responsedata);

               }

           })
           .catch((reason) => {
               if (reason?.response?.status === 440) {
                   window.location.href = "/TimeoutErrorHandler";
               }

           });

        await Axios.get(API_ROUTE + Routes.GET_ADDITION_LINES, config)
            .then((response) => {
              
                if (response && response.data) {
                    ////let responsedata = response.data;

                    ////setAdditionLines(responsedata);

                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }

            });

       await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_COMPANIES, config)
           .then((response) => {
       
               if (response && response.data) {
                   let responsedata = response.data;
                   setCompanies(responsedata);

               }

           })
           .catch((reason) => {
               if (reason?.response?.status === 440) {
                   window.location.href = "/TimeoutErrorHandler";
               }

           });

       await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_AGREEMENTS, config)
           .then((response) => {

               if (response && response.data) {
                   let responsedata = response.data;

                   setAgreements(responsedata);

               }

           })
           .catch((reason) => {
               if (reason?.response?.status === 440) {
                   window.location.href = "/TimeoutErrorHandler";
               }

           });


    }

    return (
        <div >
            <div
                style={divStyle}
                className="modal fade show"
                id="exampleModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
               
            >
                <div style={{ width: "99%", display: 'flex', justifyContent: 'center' }} >
                    <div className="modal-content" style={{ width: "99%" }} >
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <span className="SectionTitle">CW Sync</span>
                               
                            </h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={closePopupModal}></button>
                        </div>
                        <div className="modal-body">

                            <div>
                                <div className="horizontal-stepper">
                                    <div className={`h-step ${activeStep === 0 ? " active" : (activeStep > 0 ? " completed" : "")}`}>
                                        <div className="circle">
                                            <span>1</span>
                                        </div>
                                        <div className="content">Company Check</div>
                                        <div className="line"></div>
                                    </div>
                                    <div className={`h-step ${activeStep === 1 ? " active" : (activeStep > 1 ? " completed" : "")}`}>
                                        <div className="circle"><span>2</span></div>
                                        <div className="content">Check Contacts</div>
                                        <div className="line"></div>
                                    </div>
                                    <div className={`h-step ${activeStep === 2 ? " active" : (activeStep > 2 ? " completed" : "")}`}>
                                        <div className="circle"><span>3</span></div>
                                        <div className="content">Created Agreements</div>
                                        <div className="line"></div>
                                    </div>
                                    <div className={`h-step ${activeStep === 3 ? " active" : (activeStep > 3 ? " completed" : "")}`}>
                                        <div className="circle"><span>4</span></div>
                                        <div className="content">Update Additions</div>
                                    </div>
                                </div>
                            </div>
                                <StepWizard isLazyMount instance={assignStepWizard} currentStep={activeStep} onStepChange={handleStepChange}>

                                <Step1 closePopupModal={closePopupModal} companies={companies} agreements={agreements} updateAggreements={updateAggreements}  typesIds={typesIds} />
                                <Step2 closePopupModal={closePopupModal} updateAggreements={updateAggreements} typesIds={typesIds} />
                                <Step3 closePopupModal={closePopupModal} uniqueAdditionLines={uniqueAdditionLines} getallAggreements={getallAggreements }  />
                                <Step4 closePopupModal={closePopupModal} agreements={agreements} />

                                </StepWizard>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div data-act-control-type="modalPopupBackground" id="HelpModal_backgroundElement" className="Background" style={{ display: props.displayModal ? "block" : "none", backgroundColor: "black", opacity: "0.8", position: "fixed", left: "0px", top: "0px", zIndex: "10000", width: "100%", height: "100%" }} />
            <HelpModal displayModal={!helpPopup} closeModal={closeHelpModal} about="JobManagement.html" />

        </div>
    );
};

export default AdditionLineControlModal;
